import {useQuery} from 'react-query'
import {isNotEmpty, QUERIES} from '../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {JudiEditModalForm} from './JudiEditModalForm'
import {getJudiById} from '../core/_requests'
import {useState} from 'react'
import {initialJudi, Judi} from '../core/_models'

const JudiEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const [dataToUpdate, setDataToUpdate] = useState<Judi>(initialJudi)
  const {isLoading, data, error} = useQuery(
    `${QUERIES.PUBLIC_USERS_LIST}-judi-${itemIdForUpdate}`,
    () => {
      const result = getJudiById(itemIdForUpdate)
      result.then((item) => {
        setDataToUpdate(item || initialJudi)
      })
      return result
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      refetchOnWindowFocus: false,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return (
      <JudiEditModalForm
        isLoading={isLoading}
        judi={dataToUpdate}
      />
    )
  }

  if (!error) {
    // @ts-ignore
    return <JudiEditModalForm isLoading={isLoading} judi={dataToUpdate} />
  }

  return null
}

export {JudiEditModalFormWrapper}
